<template>
  <div>
    <b-button size="" variant="link" @click.prevent="$bvModal.show(modalId)">2.34</b-button>
    <b-modal :id="modalId" title="BootstrapVue">
      <ul>
        <li>
          Material
          <ul>
            <li>Esquinero:</li>
            <li>Caja:</li>
            <li>Zuncho:</li>
            <li>Clamshell:</li>
          </ul>
        </li>
        <li>
          Servicios
          <ul>
            <li>Etiquetado:</li>
            <li>Termoencogido:</li>
            <li>Termosellado:</li>
            <li>Termoformado:</li>
            <li>Termoformado:</li>
          </ul>
        </li>
      </ul>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "FormatosModalMys",
  props: {
    modalId: {
      type: String,
      default: "modal"
    }
  }
};
</script>
<style></style>
